/**
 * Even search filter types
 */
export enum EventSearchSortType {
  MODIFIED = <any>'MODIFIED',
  CREATED = <any>'CREATED',
  COMPLETED = <any>'COMPLETED'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/dashboard/event-search-sort-type-enum.ts